import { getFormattedDate } from '@/utils/date/getFormattedDate';
import { SampleDetailsPageSection } from './SampleDetailsPageSection';
import { useGetSampleDetailsQuery } from '@viome/viome-base/src/usecase/Misc/MiscQuery';

export interface SampleDetailsPageSampleInformationSectionProps
  extends React.ComponentProps<'div'> {
  isLoading?: boolean;
  sampleId?: string;
  'data-testid'?: string;
}

export const SampleDetailsPageSampleInformationSection = ({
  isLoading,
  sampleId,
  'data-testid': testId,
  ...rest
}: SampleDetailsPageSampleInformationSectionProps) => {
  const { data: samples } = useGetSampleDetailsQuery();
  const currentSample = samples?.find(
    sample => sample.sample_information.sample_id === sampleId
  );
  const sampleInformation = currentSample?.sample_information;

  const allSampleData = [
    {
      label: 'Test Name',
      value: sampleInformation?.test_name,
    },
    {
      label: 'Authorized Order Person',
      value: sampleInformation?.authorized_order_person,
    },
    {
      label: 'Sample Source',
      value: sampleInformation?.sample_source,
    },
    {
      label: 'Date Collected',
      value: getFormattedDate(sampleInformation?.date_collected),
    },
    {
      label: 'Date Received',
      value: getFormattedDate(sampleInformation?.date_recieved),
    },
    {
      label: 'Date Issued',
      value: getFormattedDate(sampleInformation?.date_issued),
    },
    {
      label: 'Sample ID',
      value: sampleInformation?.sample_id,
    },
  ];

  const sampleData = allSampleData.filter(item => {
    if (!item.value) return false;
       
    if (item.value === 'Invalid Date') return false;
    
    if (typeof item.value === 'string' && item.value.trim() === '') return false;
    
    return true;
  });

  if (sampleData.length === 0 && !isLoading) {
    return null;
  }

  return (
    <SampleDetailsPageSection
      {...rest}
      title="Sample Information"
      data={sampleData}
      isLoading={isLoading}
      data-testid={testId}
    />
  );
};